import { render, staticRenderFns } from "./externalCode.vue?vue&type=template&id=9ba85994&scoped=true&"
import script from "./externalCode.vue?vue&type=script&lang=js&"
export * from "./externalCode.vue?vue&type=script&lang=js&"
import style0 from "./externalCode.vue?vue&type=style&index=0&id=9ba85994&scoped=true&lang=css&"
import style1 from "./externalCode.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba85994",
  null
  
)

export default component.exports